exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-19ea469a]:export {\n  xrColorPrimary: #2362FB;\n}\n.red[data-v-19ea469a] {\n  color: #F56C6C;\n  margin-right: 4px;\n}\n", ""]);

// exports
